import { useQuery } from '@tanstack/react-query';
import { analyticsGetCircuitReports } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useAvailableCircuitReports = () =>
  useQuery({
    queryFn: async () => extractData(analyticsGetCircuitReports()),
    queryKey: ['Analytics', 'CircuitReports'],
  });
